import { AxiosInstance } from "axios";
import {useEffect, useState} from "react";
import useAxios from "../utils/useAxios";

const fetchCollection = async (axios: AxiosInstance ) => {
    try {

        const response = await axios.get<any>(
            `/artwork-master/collections/`,
        );

        return response.data;
    } catch (err) {
        console.error(err);
    }
    return [];
};

export default function useArtworkCollection() {
    const axios = useAxios();
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const getData = async () => {
            setIsLoading(true);
            const response = await fetchCollection(
                axios
            );

            setData(response);
            setIsLoading(false);
        };

        getData();
    }, []);

    return {data, isLoading}
}